import { combineReducers } from 'redux';
import {
  createStatusReducers,
  createMultipleLifeCycleConstants,
  createReducer,
} from 'store/utils/reducerHelpers'
import types from './types'
import { initialStoreTemplates } from 'helpers/initialState'

const STORE_TEMPLATES = createMultipleLifeCycleConstants(types)

const data = createReducer(
  initialStoreTemplates,
  {
    [STORE_TEMPLATES.fetchStoreTemplates.success]: (
      (state, action) => action.payload
    )
  }
)

const statusReducers = createStatusReducers(types)

export default combineReducers({
  data,
  ...statusReducers,
})



// WEBPACK FOOTER //
// ./src/store/storeTemplates/reducer.js